import {
  post, postExcel, put, remove, get, getWithParams,
} from '@/services/api.service';

const state = {
  vouchers: [],
  totalVouchers: 0,
  mainTableHeaders: [
    {
      text: 'Nr vouchera',
      value: 'voucher_number',
    },
    {
      text: 'Nr faktury/paragonu',
      value: 'invoice_number',
    },
    {
      text: 'Nota',
      value: 'debit_note',
      sortable: false,
    },
    {
      text: 'Imię i nazwisko',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Nazwa vouchera',
      value: 'type',
    },
    {
      text: 'Status',
      value: 'status',
    },
    {
      text: 'Termin ważności',
      value: 'expired_at',
    },
    {
      text: 'Wartość',
      value: 'price',
    },
    {
      text: 'Wartość zrealizowana',
      value: 'realized_value',
    },
    {
      text: 'Akcje',
      sortable: false,
      align: 'center',
      value: 'action',
    },
  ],
  realizationsHeaders: [
    {
      text: 'Uwagi',
      align: 'left',
      value: 'comments',
      sortable: false,
    },
    {
      text: 'Data wystawienia',
      align: 'center',
      value: 'date',
    },
    {
      text: 'Osoba',
      align: 'center',
      value: 'person',
    },
    {
      text: 'Wartość',
      align: 'center',
      value: 'price',
    },
  ],

};

const mutations = {
  setVouchers(data, payload) {
    data.vouchers = payload.data;
    data.totalVouchers = payload.total;
  },
};

const getters = {
  getVouchersList: data => data.vouchers,
  getTotalVouchers: data => data.totalVouchers,
  getMainTableHeaders: data => data.mainTableHeaders,
  getRealizationsHeaders: data => data.realizationsHeaders,
};

const actions = {
  fetchVouchers(context, payload) {
    return new Promise((resolve) => {
      getWithParams('/voucher', payload || {})
        .then((response) => {
          context.commit('setVouchers', response);
          resolve();
        });
    });
  },
  fetchVouchersExcel(context, payload) {
    return postExcel('/exportVouchers', payload);
  },
  fetchVoucherDetails(context, payload) {
    return new Promise((resolve) => {
      get(`/voucher/${payload}`)
        .then((response) => {
          resolve(response);
        });
    });
  },
  createVoucher(context, payload) {
    return new Promise((resolve, reject) => {
      post('/voucher', payload)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  addRealization(context, payload) {
    return new Promise((resolve, reject) => {
      post(`/realization/${payload.id}`, payload.formData)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  editExpiredAt(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/voucher/${payload.id}`, payload)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  editPrice(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/voucher/${payload.id}`, payload)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  editVoucher(context, payload) {
    return new Promise((resolve, reject) => {
      put(`/voucher_emp/${payload.id}`, payload)
        .then(() => {
          resolve();
        }, () => {
          reject();
        });
    });
  },
  removeVoucher(context, payload) {
    return new Promise((resolve) => {
      remove(`/voucher/${payload.id}`)
        .then(() => {
          context.dispatch('fetchVouchers', payload.searchObj);
          resolve();
        });
    });
  },
  turnOffVoucher(context, payload) {
    return new Promise((resolve) => {
      put(`/voucher/deactivate/${payload.id}`, payload.formData.status_reason ? payload.formData : null)
        .then(() => {
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
